import { Form, FormButton, FormGroup, FormInput } from "dolfo2"
import { ITournamentDeck } from "pkm-special-tool"
import React from "react"
import { makeApiCall, ServerCall, showMessage } from "../../../apis/ServerCall"
import { CanLoad } from "../../../utils/CanLoad"
import { translate } from "../../../utils/LangUtils"
import { ISendTeamProps, TEAM_LIST_URL } from "../SendTeamList"

interface IProps extends ISendTeamProps{
    item: ITournamentDeck
}

export class PokemonDeckList extends CanLoad<IProps>{
    private form: FormGroup<Partial<ITournamentDeck>>

    constructor(props: IProps){
        super(props)

        this.form = new FormGroup<Partial<ITournamentDeck>>({
            deckList: { value: props.item.deckList || "", required: !props.isAdmin },
            notes: { value: props.item.notes || "" }
        })

        if(props.isAdmin)
            this.form.disable()
    }

    private submit = () => {
        const item = this.form.getObjectValue()

        if(!this.form.isValid())
            return showMessage(translate("deckList.invalid"))

        this.form.disable()
        this.toggleLoading()

        this.props.save((id, onSuccess) => makeApiCall({
            promise: ServerCall.post(TEAM_LIST_URL + "/" + id + "/deck-list", item),
            onSuccess,
            doFinally: () => {
                this.form.enable()
                this.toggleLoading()
            }
        }))
    }

    render = () => <Form frm={this.form} onSubmit={this.submit}>
        <FormInput type="textarea" rows={10} controlName="deckList" label="DeckList" />
        <FormInput type="textarea" rows={5} controlName="notes" label={translate("deckList.notes")} />

        {!this.props.isAdmin && <div className="text-end">
            <FormButton loading={this.state.loading} color="green" shape="pill">
                {translate("teamList.submit")}
            </FormButton>
        </div>}
    </Form>
}